// [V2] 타이틀 스티키 배선 훅 — 컨덕터 소유 이식본(2026-09-09 ⑤ 1-B).
//
// 왜 여기로 옮겼나: DS 기존 폴더(pbo-core/src/components/PageHeaderParts.tsx)에서 받고 있었다.
//   그 폴더는 0.8.0 에서 삭제된다 — 신규 데모(타이틀 골격)가 쓰고 있으면 지울 수 없다.
// 무엇인가: 요소가 아니라 **배선 유틸**이다(타이틀 행 자체는 요소 조합 트리). 히스테리시스
//   (켜짐 >24 / 꺼짐 <8, capture 스크롤) 판정만 소유하고, 페인트는 CSS 클래스가 한다.
// 클래스 계약(변경 없음): 반환 ref 를 단 래퍼에 `dev-page-header-wrap pin` + isSticky 시 `sticky`
//   — 이 클래스의 CSS 는 components-desktop/elements/table.css(0.8.0 에도 남는다) 소유다.
import { useEffect, useRef, useState } from 'react'

export function usePageHeaderSticky() {
  const [isSticky, setSticky] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const onScroll = (e: Event) => {
      const el = ref.current
      if (!el) return
      const t = e.target
      const scroller = t === document ? document.documentElement : (t as HTMLElement)
      if (!(scroller instanceof HTMLElement) || !scroller.contains(el)) return
      const top = scroller.scrollTop
      setSticky((prev) => (prev ? top > 8 : top > 24))
    }
    window.addEventListener('scroll', onScroll, true)
    return () => window.removeEventListener('scroll', onScroll, true)
  }, [])
  return { ref, isSticky }
}
